import IMessage from "../interface/IMessage";
import uploadFile from "./uploadFile";
import { reportAppError } from "../utils/reportAppError";

const sendMessageToBackend = async (chatInput: IMessage): Promise<boolean> => {
  try {
    if (chatInput.content) {
      return await uploadFile(chatInput);
    }

    return await new Promise((resolve) => {
      Genesys(
        "command",
        "MessagingService.sendMessage",
        {
          message: chatInput.text,
        },
        function () {
          resolve(true);
        },
        function () {
          resolve(false);
        },
      );
    });
  } catch (error) {
    reportAppError({
      scope: "sendMessageToBackend",
      error,
      metadata: { hasAttachment: Boolean(chatInput.content) },
    });
    return false;
  }
};

export default sendMessageToBackend;
